import { render, staticRenderFns } from "./Leases.vue?vue&type=template&id=5c294e3e&scoped=true"
import script from "./Leases.vue?vue&type=script&lang=js"
export * from "./Leases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c294e3e",
  null
  
)

export default component.exports